<template>
  <v-autocomplete
    v-model="country"
    :label="label"
    :class="{ 'pt-2': noStyle, 'mt-2': noStyle }"
    :items="countryOptions"
    :menu-props="{ maxHeight: '400' }"
    :search-input.sync="countrySearch"
    color="primary"
    clearable
    autocomplete="off"
    type="text"
    item-text="text"
    item-value="value"
    :hint="hint"
    @change="handleChange"
    :disabled="disabled"
    :persistent-hint="persistentHint"
    :rules="rules"
    return-object
  ></v-autocomplete>
</template>
<script>
import constants from "@/utils/constants";

export default {
  props: {
    initialCountry: {
      type: String,
      default: String,
    },
    disabled: {
      type: Boolean,
      default: Boolean,
    },
    label: {
      type: String,
      default: "Country",
    },
    hint: {
      type: String,
      default: String,
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: Array,
    },
    noStyle: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    countryOptions: [],
    countrySearch: "",
    timeout: null,
    country: "",
  }),

  created() {
    this.countryOptions = constants.countries();
    if (this.initialCountry !== null && this.initialCountry.length !== 0) {
      this.country = this.countryOptions.find((element) => {
        return (
          element.value === this.initialCountry ||
          element.text === this.initialCountry
        );
      });
    }
  },

  methods: {
    handleChange(value = "") {
      if (Object.keys(value).length !== 0) {
        this.$emit("change", value.value);
      } else {
        this.$emit("change", "");
      }
    },
  },
};
</script>
